import * as React from 'react';

import {BulletedList} from 'shells/bulleted-list/bulleted-list';
import {OnboardingBody} from 'shells/onboarding-page/onboarding-body';
import {Body} from 'shells/typography/body';

const BULLETS = [
    <Body key='1'>
        Nutshell does not support starting with a new phone number. During the connection process,
        select <Body isBold={true}>“Connect your existing WhatsApp Business App”</Body>.
    </Body>,
    <Body key='2'>
        Adding a payment method <Body isBold={true}>is not required</Body> to use WhatsApp with
        Nutshell. When prompted, simply click “Finish” instead. Unfortunately, this isn’t something
        we can remove.
    </Body>,
];

export function BeforeYouConnect() {
    return (
        <OnboardingBody title='Two things to know before connecting:'>
            <div className='mt-16'>
                <BulletedList bullets={BULLETS} />
            </div>
        </OnboardingBody>
    );
}
